import InWorkIcon from './component'

export default InWorkIcon
